import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */
const SvgUserEmpty = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.465 15.809c-.722.194-1.539.288-2.457.288-.92 0-1.737-.094-2.459-.288a.586.586 0 00-.097.041.986.986 0 00-.13.083 7.47 7.47 0 01-.787.48l-.1.055a9.354 9.354 0 00-.84.514c-.26.185-.43.345-.524.471a.489.489 0 00-.07.124l.006.423H17v-.424l-.004-.013a.492.492 0 00-.067-.113c-.094-.127-.261-.286-.52-.47a9.262 9.262 0 00-.935-.57 7.507 7.507 0 01-.78-.477.973.973 0 00-.13-.082.575.575 0 00-.1-.042zm-.026-.007h.001-.001zm3.068 3.698c.56-.038.993-.456.993-.958v-.964c0-1.193-1.4-1.976-2.306-2.484a6.164 6.164 0 01-.6-.362c-.417-.311-.97-.525-1.47-.385-.576.16-1.273.25-2.116.25-.845 0-1.543-.09-2.12-.25-.5-.14-1.05.074-1.466.385a6.15 6.15 0 01-.606.364c-.91.508-2.316 1.291-2.316 2.482l.016.995c.018.49.445.889.991.927h11zM13.513 6.138c-.22-.333-.59-.638-1.513-.638-.922 0-1.292.305-1.513.64C10.191 6.586 10 7.357 10 8.5c0 1.09.22 1.87.542 2.335.265.383.665.665 1.458.665.794 0 1.194-.282 1.458-.664.32-.464.542-1.245.542-2.336 0-1.144-.191-1.914-.487-2.362zM15.5 8.5c0-2.504-.795-4.5-3.5-4.5S8.5 6 8.5 8.5 9.488 13 12 13c2.511 0 3.5-1.996 3.5-4.5z"
      clipRule="evenodd"
    />
  </svg>
));
SvgUserEmpty.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgUserEmpty;
